export default {
  global() {
    return {
      //production environment
      globalConfig: {
        altPictureText:
          'Gartenbau Gazi, Gartengestaltung und Pflege in Stuttgart, Reutlingen, Tübingen',
      },
    };
  },
};
